export const CUSTOMER_FORM_SECTIONS = [
  { id: 'basic', title: '基本信息' },
  { id: 'contact', title: '联系方式' },
  { id: 'billing', title: '账单设置' },
  { id: 'attachments', title: '附件与备注' }
]

export const CUSTOMER_GROUPING_DAY_OPTIONS = Array.from({ length: 28 }, (_, index) => ({
  label: `每月 ${index + 1} 日`,
  value: index + 1
}))
